<template>
  <div class="contents wrap" id="skipToContents">
    <div class="learn-tit">
      <cite>과정명</cite>
      <strong>{{ resultMap.subjNm }}</strong>
    </div>
    <div class="learn-date">
      <dl>
        <dt>
          <i class="ico-time"></i>
          학습종료까지 남은시간
        </dt>
        <dd>
          <em class="red">
            <countdown ref="learnCountdown" :time="resultMap.learnRemainSec * 1000">
              <template slot-scope="props">{{ props.days }}일 {{ props.hours }}시 {{ props.minutes }}분 {{ props.seconds }}초</template>
            </countdown>
          </em>
        </dd>
      </dl>
      <dl>
        <dt>&nbsp;&nbsp; 학습기간</dt>
        <dd>
          <b>{{ resultMap.learnStartDt | dateTimeShortFormat }} ~ {{ resultMap.learnEndDt | dateTimeShortFormat }}</b>
        </dd>
      </dl>
    </div>

    <div class="site-contents">
      <ul class="learn-nav">
        <li :class="$route.path.indexOf('main') > -1 ? 'current' : ''">
          <a @click="goMenu('MAIN')">
            <i class="home"></i>
            홈
          </a>
        </li>
        <li :class="$route.path.indexOf('lesson') > -1 ? 'current' : ''"><a @click="goMenu('LESSON')">학습목차</a></li>
        <li :class="$route.path.indexOf('10013') > -1 ? 'current' : ''"><a @click="goMenu('NOTICE')" title="공지사항">공지사항</a></li>
        <li v-for="item in resultEfList" :key="item.efCd">
          <a @click="goMenu(item)" :title="item.efNm">{{ item.efNm }}</a>
        </li>
      </ul>

      <slot />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { apiURL } from "@/utils";
import VueCountdown from "@chenfengyuan/vue-countdown";
Vue.component(VueCountdown.name, VueCountdown);

export default {
  name: "LearnLayout",
  components: {},
  data: function () {
    return {
      enrollNo: this.$route.params.enrollNo,
      resultEfList: [],
      resultMap: {
        learnRemainSec: 0,
      },
    };
  },
  created() {
    // 메뉴 번호 강제 설정.
    this.$store.dispatch("setCurrentMenu", "225");
    this.getLearnInfo();
  },
  methods: {
    getLearnInfo() {
      this.request(`${apiURL}/learn/info/${this.enrollNo}`).then(({ data }) => {
        this.resultMap = data.resultMap;
        this.resultEfList = data.resultEfList;
      });
    },
    goMenu(menu) {
      if (menu == "MAIN") this.$router.push(`/usr/learn/main/${this.enrollNo}`);
      if (menu == "LESSON") this.$router.push(`/usr/learn/lesson/${this.enrollNo}`);
      if (menu == "NOTICE") this.$router.push(`/usr/learn/bbs/${this.enrollNo}/10013`);
      if (menu == "EXAM") this.$router.push(`/usr/learn/exam/list/${this.enrollNo}`);
      if (menu == "SURVEY") this.$router.push(`/usr/learn/survey/list/${this.enrollNo}`);
    },
  },
};
</script>
